import { render, staticRenderFns } from "./addProductAttr.vue?vue&type=template&id=f3b24b10&scoped=true&"
import script from "./addProductAttr.vue?vue&type=script&lang=js&"
export * from "./addProductAttr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b24b10",
  null
  
)

export default component.exports